import { InformationModal, DefaultPrimaryButton, DefaultSecondaryButton } from "@/styles/globalstyles";
import { Modal, Box, Typography, Divider, Button } from "@mui/material";
import CloseButton from "../../buttons/CloseButton";
import { Upload } from "@mui/icons-material";
import { useRef, useState } from "react";

interface ImportExchangeRatePartModalProps {
  open: boolean;
  handleClose: () => void;
  onImport: (file: File) => void;
}

const ImportExchangeRatePartModal = ({
  open,
  handleClose,
  onImport,
}: ImportExchangeRatePartModalProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [error, setError] = useState<string>("");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.name.endsWith(".xlsx");

    if (!isExcel) {
      setError("กรุณาเลือกไฟล์ .xlsx เท่านั้น");
      setSelectedFile(null);
      return;
    }

    setError("");
    setSelectedFile(file);
  };

  const handleConfirmImport = () => {
    if (!selectedFile) {
      setError("กรุณาเลือกไฟล์ก่อน");
      return;
    }
    onImport(selectedFile);
    onClose();
  };

  const onClose = () => {
    setSelectedFile(null);
    setError("");
    if (fileInputRef.current) fileInputRef.current.value = "";
    handleClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...InformationModal, maxHeight: "90vh" }}>
        <CloseButton onClick={onClose} />
        <Typography variant="h2">Import Exchange Rate Part</Typography>
        <Box p={1}>
          <Divider sx={{ my: 1 }} />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={2}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              backgroundColor: "#f9f9f9",
            }}
          >
            <Box>
              <Typography fontWeight="bold" fontSize={14}>
                อัปโหลดไฟล์
              </Typography>
              <Typography variant="body2" color="textSecondary" fontSize={12}>
                {selectedFile ? selectedFile.name : "ยังไม่ได้เลือกไฟล์ (.xlsx)"}
              </Typography>
              {error && (
                <Typography color="error" fontSize={12} mt={0.5}>
                  {error}
                </Typography>
              )}
            </Box>
            <Button
              variant="outlined"
              startIcon={<Upload />}
              onClick={() => fileInputRef.current?.click()}
              sx={{ ...DefaultSecondaryButton, width: "180px", fontSize: "0.9rem" }}
            >
              เลือกไฟล์
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Box>
        </Box>

        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" size="small" sx={{ ...DefaultSecondaryButton, width: "120px", fontSize: "0.9rem" }} onClick={onClose}>
            ยกเลิก
          </Button>
          <Button
            size="small"
            variant="contained"
            sx={{ ...DefaultPrimaryButton, width: "120px", fontSize: "0.9rem" }}
            onClick={handleConfirmImport}
            disabled={!selectedFile}
          >
            นำเข้าข้อมูล
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ImportExchangeRatePartModal;
